import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./css/language.css";
import useTranslation from "../hooks/useTranslation";

// Importar las banderas
import banderaEspana from "../assets/flags/Bandera-España.webp";
import banderaReinoUnido from "../assets/flags/Bandera-ReinaUnido.webp";
import banderaBulgaria from "../assets/flags/Bandera-Bulgaria.png";
import banderaRepublicaCheca from "../assets/flags/Bandera-RepublicaCheca.png";
import banderaFinlandia from "../assets/flags/Bandera-Finlandia.png";
import banderaGrecia from "../assets/flags/Bandera-Grecia.png";

function Language({ selectedLanguage: savedLanguage, setSelectedLanguage: saveLanguage, updateProgress }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedLanguage, setSelectedLanguage] = useState(savedLanguage || null);

  // Configuración de idiomas con sus respectivas banderas
  const languages = [
    { id: 'es', name: 'Español', flag: banderaEspana },
    { id: 'en', name: 'English', flag: banderaReinoUnido },
    { id: 'bg', name: 'Български', flag: banderaBulgaria },
    { id: 'cs', name: 'Čeština', flag: banderaRepublicaCheca },
    { id: 'fi', name: 'Suomi', flag: banderaFinlandia },
    { id: 'el', name: 'Ελληνικά', flag: banderaGrecia }
  ];

  const handleLanguageSelect = (languageId) => {
    setSelectedLanguage(languageId);
  };

  const handleContinue = () => {
    if (selectedLanguage) {
      saveLanguage(selectedLanguage);
      updateProgress('language');
      // Recargar la página para que el nuevo idioma se aplique
      window.location.href = '/intro';
    }
  };

  return (
    <div className="language-container">
      {/* Título principal */}
      <div className="language-title">
        <h1>SELECT YOUR LANGUAGE</h1>
      </div>

      {/* Grid de idiomas */}
      <div className="languages-grid">
        {languages.map((language) => {
          const isSelected = selectedLanguage === language.id;
          const backgroundColor = isSelected ? '#4CAF50' : '#c2c6c8b5';
          
          return (
            <div
              key={language.id}
              className={`language-card ${isSelected ? 'selected' : ''}`}
            >
              <div 
                className="language-card-top"
                style={{ backgroundColor: backgroundColor }}
              >
                <div className="flag-wrapper">
                  <img 
                    src={language.flag} 
                    alt={`${language.name} flag`} 
                    className="flag-image" 
                  />
                </div>
              </div>
              <div className="language-card-bottom">
                <button 
                  className="select-button"
                  onClick={() => handleLanguageSelect(language.id)}
                >
                  SELECT
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* Botón Continue */}
      <div className="continue-section">
        <button 
          className={`continue-button ${selectedLanguage ? 'active' : 'disabled'}`}
          onClick={handleContinue}
          disabled={!selectedLanguage}
        >
          CONTINUE
        </button>
      </div>

      {/* Elementos decorativos del skyline */}
      <div className="city-skyline"></div>
    </div>
  );
}

export default Language;
